import { useState } from 'react';

function TabNavigation({ children }) {
  const [activeTab, setActiveTab] = useState('wheel');

  const tabs = [
    { id: 'wheel', label: 'Ruleta' },
    { id: 'history', label: 'Historial' }
  ];

  return (
    <div className="flex flex-col flex-grow">
      {/* Navegación de pestañas con fondo blanco */}
      <div className="relative z-header bg-white border-b border-secondary-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <nav className="-mb-px flex space-x-8">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`
                  whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm
                  ${activeTab === tab.id
                    ? 'border-primary-500 text-primary-600'
                    : 'border-transparent text-secondary-500 hover:text-secondary-700 hover:border-secondary-300'
                  }
                `}
              >
                {tab.label}
              </button>
            ))}
          </nav>
        </div>
      </div>

      {/* Contenido de las pestañas - sin z-index aquí */}
      <div className="flex-grow">
        {children(activeTab)}
      </div>
    </div>
  );
}

export default TabNavigation; 